import React from 'react';
import { Outlet } from 'react-router-dom';
import { PushNotificationPrompt } from '../PushNotification';
import FloatingChat from '../FloatingChat';

// Sidebar is intentionally REMOVED from the global layout.
// Navigation happens via the Main Menu (`/`) — modules show a Home button in their Header
// to return to the menu. This keeps each module focused and reduces clutter.
const Layout = () => {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-neutral-950">
      <main className="min-h-screen">
        <Outlet />
      </main>

      {/* Push Notification Prompt */}
      <PushNotificationPrompt />

      {/* Floating Chat */}
      <FloatingChat />
    </div>
  );
};

export default Layout;
